import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { ItineraryBuilderDayClientService } from '@app/itinerary-builder-sdk/services/itinerary-builder-day-client.service';
import { ItineraryDay } from '@app/itinerary-builder-sdk/interfaces/itinerary-day';
import { ItineraryItem } from '@app/itinerary-builder-sdk/interfaces/itinerary-item';
import { ModalController } from '@ionic/angular';
import { LikedListingsComponent } from '../../liked-listings/liked-listings.component';

import moment from 'moment';
import { FavoriteListingsComponent } from '@app/codebase/itinerariesv2/favorite-listings/favorite-listings.component';
import { environment } from '@env/environment';
declare function require(name:string);

@Component({
  selector: 'app-itinerary-day-cell',
  templateUrl: require('template/' + environment.template + '/html/itinerary-day-cell.component.html'),
  styles: [require('template/' + environment.template + '/styles/itinerary-day-cell.component.scss')]
})
export class ItineraryDayCellComponent implements OnInit {

  public environment = environment;
  @Output() stopChanged = new EventEmitter<{
    action: string,
    dayId: number,
    dayIndex: number,
    stopId: number,
    listingId?: number,
    eventId?: number
    startTime?: string,
    endTime?: string
  }>();
  @Output() dayChanged = new EventEmitter<{ action: string, dayId: number, dayIndex: number, date?: string }>();
  public date!: Date;
  @Input() public day: ItineraryDay;
  @Input() public dayIndex!: number;
  public stops!: ItineraryItem[];
  public itineraryType: string;

  constructor(
    private itineraryBuilderDayClientService: ItineraryBuilderDayClientService,
    private route: ActivatedRoute,
    private modalController: ModalController,
  ) {
    this.itineraryType = this.route.snapshot.queryParams.type;
  }

  ngOnInit() {
    this.stops = this.day.ItineraryItems;
    this.date = new Date(this.day.ItineraryDayDate);
  }

  getDate(date){
    return moment(date).format("MMMM Do");
  }

  onDeleteDayTap() {
    this.dayChanged.emit({ action: 'delete', dayId: this.day.Id, dayIndex: this.dayIndex });
  }

  onEditDayDateChanged(date: any) {
    const newDate = date.detail.value;
    this.dayChanged.emit({ action: 'edit', dayId: this.day.Id, dayIndex: this.dayIndex, date: newDate });
    this.day.ItineraryDayDate = newDate;
    this.date = new Date(this.day.ItineraryDayDate);
  }

  public onStopChanged(event: {
    action: string, stopId: number, listingId?: number, eventId?: number, startTime?: string, endTime?: string
  }) {
    if (event) {
      this.stopChanged.emit({
        action: event.action,
        dayId: this.day.Id,
        dayIndex: this.dayIndex,
        stopId: event.stopId,
        listingId: event.listingId,
        eventId: event.eventId,
        startTime: event.startTime,
        endTime: event.endTime
      });
    } else {
      console.error('>>> invalid event');
    }
  }

  public trackBy(index: number, item: { Id: string }) {
    if (!item) {
      return null;
    }
    return item.Id;
  }

  async onAddElementButtonClick() {
    const modal = await this.modalController.create({
      component: FavoriteListingsComponent,
      componentProps: {
        itineraryId: this.route.snapshot.params.id,
        dayId: this.day.Id,
      }
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    if (data && data.updated && data.itineraryItem) {
      this.stops.push(data.itineraryItem);
    } else {
      ////console.log('>>> Nothing changed');
    }
  }

}
